module.exports = __webpack_public_path__ + "img/aiguplogo@3x.7917c2c4.png";